import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ServiceLogo from 'assets/images/Dashboard/Logo.png';
import ReusableButton from 'components/common/Button';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { superAdminCampaigns } from 'routes/AppUrls';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import leftArrow from 'assets/images/Dashboard/arrow-left.png';
import SelectInput from 'components/common/Input/SelectInput';
import { useDropzone } from 'react-dropzone';
import ReusableDateRangePicker from 'components/common/DateRangePicker';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentDaysProviderCallAPI } from 'store/AppointmentDaysList/action';
import { addCampaignCallAPI } from 'store/SuperAdmin/createCampaign/action';
import ToastNotification from 'components/common/Toast';
import CheckValidation from 'utils/Validation';
import moment from 'moment';
import dayjs from 'dayjs';
import { imageUploadCallAPI } from 'store/ImageUpload/action';
import { updateCampaignCallAPI } from 'store/SuperAdmin/updateCampaign/action';
import CircularProgress from '@mui/material/CircularProgress';

const BrandBasedCampaign = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [isError, setIsError] = useState(null);
  const [conf, setConf] = ToastNotification();
  const { state } = useLocation();
  const [latLng, setLatLng] = useState({ lat: 28.525377, lng: 77.280106 });

  const campaignLoader = useSelector(
    (state) =>
      state?.addCampaignReducer?.loading ||
      state?.updateCampaignReducer?.loading
  );

  const [bannerImage, setBannerImage] = useState(
    state?.campaignData
      ? state?.campaignData?.english_banner_image?.file_url
      : null
  );
  const [dateRange, setDateRange] = useState([
    state?.campaignData ? dayjs(state?.campaignData?.start_date) : null,
    state?.campaignData ? dayjs(state?.campaignData?.end_date) : null,
  ]);

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );
  const dayListData = useSelector(
    (state) => state?.getAppointmentDaysReducer?.data?.data
  );
  const [selectedDay, setSelectedDay] = useState(
    state?.campaignData
      ? state?.campaignData?.weekday?.length > 0
        ? state.campaignData.weekday.map((k) => k?.id)
        : []
      : dayListData?.length > 0
        ? dayListData.map((k) => k?.id)
        : []
  );

  const [formValue, setFormValue] = useState({
    campaignName: state?.campaignData ? state?.campaignData?.name : '',
    country: state?.campaignData ? state?.campaignData?.country?.name : '',
    city: state?.campaignData ? state?.campaignData?.cities?.name : '',
    link: state?.campaignData ? state?.campaignData?.english_link : '',
    startDate: state?.campaignData
      ? dayjs(state?.campaignData?.start_date)
      : '',
    endDate: state?.campaignData ? dayjs(state?.campaignData?.end_date) : '',
    description: state?.campaignData
      ? state?.campaignData?.english_description
      : '',
    bannerImage: state?.campaignData
      ? state?.campaignData?.english_banner_image?.id
      : null,
    brands: [],
  });

  const [formId, setFormId] = useState({
    country: state?.campaignData ? state?.campaignData?.country?.id : '',
    city: state?.campaignData ? state?.campaignData?.cities?.id : '',
  });

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Campaigns" />,
      Link: superAdminCampaigns(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Brand Based" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value?.name });
    setFormId({ ...formId, [name]: value?.id });
    if (name === 'city') {
      setLatLng({ lat: value?.latitude, lng: value?.longitude });
    }
  };

  const handleWeekdaySelect = (value) => {
    setSelectedDay((prev) => {
      if (prev.includes(value.id)) {
        return prev.filter((id) => id !== value.id);
      } else {
        return [...prev, value.id];
      }
    });
  };

  const handleDateRange = (value) => {
    setDateRange(value);
    setFormValue({
      ...formValue,
      ['startDate']: value?.[0],
      ['endDate']: value?.[1],
    });
  };

  /////////////////Drag & Drop //////////////////

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      let formData = new FormData();
      formData.append('filePath', acceptedFiles[0]);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleImageSuccess(res),
        })
      );
    }
  };

  const handleImageSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setBannerImage(res?.data?.data?.[0]?.filePath);
    setFormValue({ ...formValue, ['bannerImage']: res?.data?.data?.[0]?.id });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/png, image/jpeg',
    multiple: false, // Only allow single file upload
  });

  const handleCreateCampaign = () => {
    const {
      campaignName,
      country,
      city,
      description,
      startDate,
      endDate,
      // brands,
    } = formValue;
    const error = CheckValidation({
      campaignName,
      country,
      city,
      description,
      startDate,
      endDate,
      // brands,
    });
    setIsError(error);
    if (error.submit) {
      if (!formValue?.bannerImage) {
        return setConf({
          msg: 'banner image is required. Please upload a banner image.',
          variant: 'error',
        });
      }

      if (selectedDay.length === 0) {
        return setConf({
          msg: 'active days is required. Please select aactive days.',
          variant: 'error',
        });
      }

      let body = {
        name: formValue?.campaignName,
        arbic_name: formValue?.campaignName,
        english_banner_image: formValue?.bannerImage,
        arbic_banner_image: formValue?.bannerImage,
        cities: formId?.city,
        country: formId?.country,
        start_date:
          moment(formValue?.startDate?.['$d']).format('YYYY-MM-DD') ?? '',
        end_date: moment(formValue?.endDate?.['$d']).format('YYYY-MM-DD') ?? '',
        campaign_type: state?.campaignTypeId,
        english_description: formValue?.description,
        arbic_description: formValue?.description,
        weekday: selectedDay ?? [],
        promotion_categories: [],
        promotion_providers: [],
        promotion_discounts: [],
      };
      state?.campaignData
        ? dispatch(
            updateCampaignCallAPI(body, {
              id: state?.campaignData?.id,
              run: true,
              latlng: latLng,
              handleFunction: (res) => handleRedirect(res),
              toast: true,
              handleToastError: (res) => handleRedirectError(res),
              navigate: navigate,
            })
          )
        : dispatch(
            addCampaignCallAPI(body, {
              run: true,
              handleFunction: (res) => handleRedirect(res),
              toast: true,
              latlng: latLng,
              handleToastError: (res) => handleRedirectError(res),
              navigate: navigate,
            })
          );
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    navigate(superAdminCampaigns(locale));
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <div className="flex justify-between items-center">
            <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
              <Stack direction="horizontal" gap={2} className="items-center">
                <img
                  src={leftArrow}
                  alt="icon"
                  style={{ height: '32px', width: '32px' }}
                  className="cursor-pointer"
                  onClick={() => navigate(superAdminCampaigns(locale))}
                />
                <p className="p-0 m-0">
                  <FormattedMessage id="Brand Based" />
                </p>
              </Stack>
            </h2>
            <img
              src={ServiceLogo}
              alt={'logo'}
              style={{ height: '64px', width: '96px' }}
            />
          </div>

          <Col sm={12} md={6} className="">
            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Campaign Name" />}
                placeholder={intl.formatMessage({
                  id: 'Campaign Name',
                })}
                name="campaignName"
                type="text"
                value={formValue?.campaignName}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.campaignName?.error &&
                  isError?.campaignName?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Validity" />
              </p>
              <div className="mt-2">
                <ReusableDateRangePicker
                  value={dateRange}
                  onChange={handleDateRange}
                  errorText={
                    isError &&
                    (isError?.startDate?.error || isError?.endDate?.error) &&
                    (isError?.startDate?.errorMessage ||
                      isError?.endDate?.errorMessage)
                  }
                />
              </div>
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Description" />}
                placeholder={intl.formatMessage({ id: 'Description' })}
                height="160"
                multiline
                name="description"
                value={formValue?.description}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.description?.error &&
                  isError?.description?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Select Brands" />}
                placeholder={intl.formatMessage({
                  id: 'Select Brands',
                })}
                name={'brands'}
                value={formValue?.brands}
                // data={countryList?.data}
                onChange={(e) => handleInputChange(e)}
                // errorText={isError && isError.brands.error && isError.brands.errorMessage}
              />
            </Col>
          </Col>

          <Col sm={12} md={6} className="">
            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Country" />}
                placeholder={intl.formatMessage({ id: 'Country' })}
                name={'country'}
                value={formValue?.country}
                data={countryCityData}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError.country.error &&
                  isError.country.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="City" />}
                placeholder={intl.formatMessage({ id: 'City' })}
                name={'city'}
                value={formValue?.city}
                data={
                  countryCityData?.find(
                    (value) => value?.name === formValue?.country
                  )?.city || []
                }
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError && isError.city.error && isError.city.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Active Days" />
              </p>
              <div className="mt-2  gap-3 flex text-center flex-wrap">
                {dayListData?.length > 0 &&
                  dayListData.map((item, index) => (
                    <div
                      className={`weekdaysCampaign ${selectedDay.includes(item?.id) ? 'bc-292D32' : 'bc-FFFFFF'} cursor-pointer`}
                      onClick={() => handleWeekdaySelect(item)}
                    >
                      <p
                        className={`p-0 m-0 fs-14 ${selectedDay.includes(item?.id) ? 'fc-FFFFFF' : 'fc-9A9A9A'}  fw-500 ff-Akkurat`}
                      >
                        {item?.name?.substring(0, 2)}
                      </p>
                    </div>
                  ))}
              </div>
            </Col>

            <Col xs={12} md={12} className="pt-4 mt-4">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Banner Image" />
              </p>
              <div
                {...getRootProps()}
                className={`mt-2 bannerImage flex justify-center items-center cursor-pointer ${
                  isDragActive ? 'border-2 bColor-292D32' : ''
                }`}
              >
                <input {...getInputProps()} />
                {bannerImage ? (
                  <div>
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {bannerImage.name}
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Drag & Drop or Browse to change" />
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Drag & Drop or Browse" />
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Only png & jpg formats are supported" />
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat">
                      <FormattedMessage id="Minimum image resolution should be 360x300" />
                    </p>
                  </div>
                )}
              </div>
              {bannerImage ? (
                <div className="mt-4">
                  <img
                    src={bannerImage}
                    alt="Preview"
                    style={{
                      width: '100%',
                      height: '235px',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              ) : (
                <div className="mt-4 border-2 border-dashed  bannerImage flex justify-center items-center h-[235px]">
                  <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="No image uploaded yet! (resolution 360 * 300)" />
                  </p>
                </div>
              )}
            </Col>
          </Col>

          <Row className="mt-4 items-end m-0 p-0">
            <div className="flex justify-end">
              <Stack direction="horizontal" gap={3} className="items-center">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => navigate(superAdminCampaigns(locale))}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  endIcon={
                    campaignLoader && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleCreateCampaign()}
                >
                  <FormattedMessage id="Save & Add" />
                </ReusableButton>
              </Stack>
            </div>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default BrandBasedCampaign;
